function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { observable, reaction, configure } from 'mobx';
import { getListBindCard, getListMerchantBindCard, postSubCreate, getBillStatus } from './services/card';
import { isLaxNull, safeFormat } from './utils/tool';
import { InvalidCKOStartTime } from './constants';
import { EEvent, ECreateSubStatus } from './types/card';

/** 配置状态隔离，避免宿主同时用了不同版本的mobx */
configure({
  isolateGlobalState: true
});

/**
 * - 按道理jotai的值要保留一份在moobx，返回mobx内的克隆数据出去
 * - 所有原页面私有状态（非ui）都必须要保留一份在mobx，返回mobx内的克隆数据出去
 */
var eventOb = observable({
  type: '',
  eventRaw: {},
  set initSDK(params) {
    var eventRaw = params.eventRaw;
    // test
    this.eventRaw = eventRaw;
  }
});

// createSub
reaction(function () {
  return eventOb.type;
}, /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
    var appId, bizType, subBizType, subId, spuId, skuId, currency, region, promotion, subType, extUserId, buyNum, upgradeType, bizOwnerNo, bizOrderNo, returnUrl, bizCreateSub, onCreateSubError, eventRaw, createSubRst, baseReqParams, _createSubRst, _createSubRst4, _ob$billDetail, _createSubRst2, _createSubRst3, _createSubRst$error, _createSubRst$error2, _createSubRst5;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appId = ob.appId, bizType = ob.bizType, subBizType = ob.subBizType, subId = ob.subId, spuId = ob.spuId, skuId = ob.skuId, currency = ob.currency, region = ob.region, promotion = ob.promotion, subType = ob.subType, extUserId = ob.extUserId, buyNum = ob.buyNum, upgradeType = ob.upgradeType, bizOwnerNo = ob.bizOwnerNo, bizOrderNo = ob.bizOrderNo, returnUrl = ob.returnUrl, bizCreateSub = ob.bizCreateSub, onCreateSubError = ob.onCreateSubError;
            eventRaw = eventOb.eventRaw;
            // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
            baseReqParams = bizType === 'SHOPLINE' ? {
              appId: appId,
              bizType: bizType,
              subBizType: subBizType
            } : {};
            if (!(type === EEvent.ON_PAY_AND_BIND_CLICK)) {
              _context.next = 23;
              break;
            }
            if (ob.billId) {
              _context.next = 20;
              break;
            }
            if (!(typeof bizCreateSub === 'function')) {
              _context.next = 11;
              break;
            }
            _context.next = 8;
            return bizCreateSub({
              skuId: skuId,
              promotion: promotion,
              buyNum: buyNum
            });
          case 8:
            createSubRst = _context.sent;
            _context.next = 14;
            break;
          case 11:
            _context.next = 13;
            return postSubCreate(_objectSpread({}, eventRaw)).then(function (res) {
              // eslint-disable-next-line no-console
              console.log(res.data, '<<<<<<<<1');
            }).catch(function (err) {
              // eslint-disable-next-line no-console
              console.log(err, '<<<内部下单接口问题');
              eventOb.type = '';
            });
          case 13:
            createSubRst = _context.sent;
          case 14:
            // 更新billId
            if (!isLaxNull((_createSubRst = createSubRst) === null || _createSubRst === void 0 ? void 0 : _createSubRst.billId)) {
              ob.billId = (_createSubRst2 = createSubRst) === null || _createSubRst2 === void 0 ? void 0 : _createSubRst2.billId;
              // 设置下单获取到billId的标志位
              ob.isBillIdByCreateSub = true;
              ob.createSubStatus = (_createSubRst3 = createSubRst) === null || _createSubRst3 === void 0 ? void 0 : _createSubRst3.billId;
            }
            if (!((_createSubRst4 = createSubRst) !== null && _createSubRst4 !== void 0 && _createSubRst4.billId) || createSubRst.error) {
              // setStateAtom((draft) => {
              //   draft.payLoading = false;
              // });

              console.error('下单失败, 执行钩子函数：onCreateSubError', createSubRst.error);
              onCreateSubError === null || onCreateSubError === void 0 ? void 0 : onCreateSubError({
                code: (_createSubRst$error = createSubRst.error) === null || _createSubRst$error === void 0 ? void 0 : _createSubRst$error.code,
                msg: (_createSubRst$error2 = createSubRst.error) === null || _createSubRst$error2 === void 0 ? void 0 : _createSubRst$error2.msg
              });
              ob.createSubStatus = ECreateSubStatus.FAIL;
            }

            // 如果实付金额为0，则不需要拉起支付流程，后端接口会异步将账单设置为“已支付”
            if (!(((_ob$billDetail = ob.billDetail) === null || _ob$billDetail === void 0 ? void 0 : _ob$billDetail.settleAmount) === 0)) {
              _context.next = 20;
              break;
            }
            _context.next = 19;
            return getBillStatus(_objectSpread(_objectSpread({}, baseReqParams), {}, {
              billId: (_createSubRst5 = createSubRst) === null || _createSubRst5 === void 0 ? void 0 : _createSubRst5.billId
            }));
          case 19:
            ob.createSubStatus = ECreateSubStatus.BREAK;
          case 20:
            if ([ECreateSubStatus.FAIL, ECreateSubStatus.BREAK].includes(ob.createSubStatus)) {
              // // eslint-disable-next-line no-console
            }
            ob.creditCardPayModalVisible = true;

            // 事件执行完成后，记得重置，不然外部再次点击不会生效
            eventOb.type = '';
          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

// ps：以下代码还含有组件状态和逻辑状态耦合，需要业务开发协助校对
// 一些基础observable可考虑继承给下方业务observable
// 命名风格考虑重新统一
var ob = observable({
  // ===========changeCreditCardModal start==========================
  appId: '',
  bizType: '',
  subBizType: '',
  subId: '',
  spuId: '',
  skuId: '',
  currency: '',
  region: '',
  promotion: '',
  subType: '',
  extUserId: '',
  buyNum: 0,
  upgradeType: '',
  bizOwnerNo: '',
  bizOrderNo: '',
  returnUrl: '',
  merchantNo: '',
  countryCode: '',
  payMethodProps: {},
  selectCard: '',
  curCardId: '',
  // event data
  payMethod: '',
  billDetail: {},
  billId: '',
  creditCardPayModalVisible: false,
  isBillIdByCreateSub: false,
  // ===========changeCreditCardModal end==========================

  // ===========useCardListState start==========================
  // 判断是否走合并账单场景
  insideStore: true,
  // 卡列表数据
  cardData: [],
  // 下单结果状态
  createSubStatus: '',
  onCreateSubError: function onCreateSubError() {},
  bizCreateSub: function bizCreateSub() {},
  changeCardModalVisible: false,
  // todo：外部子应用并没有引用，都是自身闭环，可删
  // 判断地区是否为中国
  get isCN() {
    return this.countryCode === 'CN';
  },
  // 获取当前渲染到页面上的卡列表
  get currentRenderedCardList() {
    return this.cardData;
  },
  // 获取全部的卡数据
  get getAllCardList() {
    return this.cardData;
  },
  // 解析失效开始时间
  get invalidStartTime() {
    var _this$cardData;
    var invalidStartTime = (_this$cardData = this.cardData) === null || _this$cardData === void 0 ? void 0 : _this$cardData.invalidStartTime;
    if (invalidStartTime) {
      return safeFormat(invalidStartTime, {
        pattern: 'YYYY-MM-DD'
      });
    }

    // 详见 https://shopline.atlassian.net/browse/BUG20-31093 问题备注
    return InvalidCKOStartTime;
  },
  // ===========useCardListState end==========================
  // ===========changeCreditCardModal start==========================
  // 筛选当前卡片信息
  get findCurrentCard() {
    var _this$currentRendered,
      _this = this;
    return (_this$currentRendered = this.currentRenderedCardList) === null || _this$currentRendered === void 0 ? void 0 : _this$currentRendered.find(function (item) {
      return item.bindUniqueId === _this.curCardId;
    });
  },
  set handleSelectCard(value) {
    // value 为外部调用当前上述findCurrentCard拿到的值
    this.selectCard = value;
  },
  set handleCurCardId(value) {
    this.curCardId = value;
  },
  // ===========changeCreditCardModal end==========================

  // 【该链路的起点】设置store的值 -> 为了让condition条件返回为true -> when监听到，触发副作用
  set initSDK(params) {
    var appId = params.appId,
      bizType = params.bizType,
      subBizType = params.subBizType,
      merchantNo = params.merchantNo,
      countryCode = params.countryCode,
      payMethodProps = params.payMethodProps,
      selectCard = params.selectCard,
      subId = params.subId,
      spuId = params.spuId,
      skuId = params.skuId,
      currency = params.currency,
      region = params.region,
      promotion = params.promotion,
      subType = params.subType,
      extUserId = params.extUserId,
      buyNum = params.buyNum,
      upgradeType = params.upgradeType,
      bizOrderNo = params.bizOrderNo,
      bizOwnerNo = params.bizOwnerNo,
      returnUrl = params.returnUrl,
      bizCreateSub = params.bizCreateSub,
      billDetail = params.billDetail,
      insideStore = params.insideStore;
    // jotai状态
    this.appId = appId;
    this.bizType = bizType;
    this.subBizType = subBizType;
    this.merchantNo = merchantNo;
    this.countryCode = countryCode;
    this.payMethodProps = payMethodProps;
    this.selectCard = selectCard;
    this.subId = subId;
    this.spuId = spuId;
    this.skuId = skuId;
    this.currency = currency;
    this.region = region;
    this.promotion = promotion;
    this.subType = subType;
    this.extUserId = extUserId;
    this.buyNum = buyNum;
    this.upgradeType = upgradeType;
    this.bizOwnerNo = bizOwnerNo;
    this.bizOrderNo = bizOrderNo;
    this.returnUrl = returnUrl;
    this.bizCreateSub = bizCreateSub;
    this.billDetail = billDetail;
    this.insideStore = insideStore;

    // // 组件私有状态
    // this.curCardId = selectCard
  },

  set initLogic(params) {
    this.changeCardModalVisible = params.changeCardModalVisible;
  }
});

// ===========useCardListState start==========================
// 到时候对接react，会用mobx-react对应api替换掉
// todo：补上mobx的try...catch...
reaction(function () {
  return ob.changeCardModalVisible;
}, /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(condition) {
    var _ob$payMethodProps, _ob$payMethodProps2;
    var appId, bizType, subBizType, baseReqParams, isNeedInitStoreCardList, result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (condition) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            appId = ob.appId, bizType = ob.bizType, subBizType = ob.subBizType; // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
            baseReqParams = bizType === 'SHOPLINE' ? {
              appId: appId,
              bizType: bizType,
              subBizType: subBizType
            } : {};
            isNeedInitStoreCardList = (_ob$payMethodProps = ob.payMethodProps) !== null && _ob$payMethodProps !== void 0 && _ob$payMethodProps.isNeedInitStoreCardList ? (_ob$payMethodProps2 = ob.payMethodProps) === null || _ob$payMethodProps2 === void 0 ? void 0 : _ob$payMethodProps2.isNeedInitStoreCardList : true;
            if (!isNeedInitStoreCardList) {
              _context2.next = 18;
              break;
            }
            if (!ob.insideStore) {
              _context2.next = 12;
              break;
            }
            _context2.next = 9;
            return getListBindCard(baseReqParams);
          case 9:
            _context2.t0 = _context2.sent;
            _context2.next = 15;
            break;
          case 12:
            _context2.next = 14;
            return getListMerchantBindCard();
          case 14:
            _context2.t0 = _context2.sent;
          case 15:
            result = _context2.t0;
            ob.cardData = result.data;
            // 触发完后，记得清空条件，保证再次调用能执行reaction
            ob.changeCardModalVisible = false;
          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
reaction(function () {
  return ob.merchantNo;
}, function (merchantNo) {});
// ===========useCardListState end==========================

// ===========changeCreditCardModal start==========================

// ===========changeCreditCardModal end==========================

export { ob, eventOb };